import { mode } from "@chakra-ui/theme-tools";

/** OnlyWine — light mantém a base Horizon; dark usa fundo #111822 e primário #CF305D. */
export const globalStyles = {
  colors: {
    contrast: "#000000",
    grey: {
      grey25: "#FCFCFD",
      grey100: "#F2F4F7",
      grey200: "#475467",
      grey300: "#D0D5DD",
      grey400: "#98A2B3",
      grey500: "#667085",
      grey600: "#EAECF0",
      grey800: "#FCFCFD",
    },
    alert: {
      warning: "#F79009",
      success: "#12B76A",
      info: "#2E90FA",
      error: "#F53F3F",
    },
    brand: {
      50: "#FDF2F5",
      100: "#F5DFE5",
      200: "#EBC0CC",
      300: "#D98A9E",
      400: "#D94A72",
      500: "#CF305D",
      600: "#B82A52",
      700: "#9E2448",
      800: "#7A1D38",
      900: "#501326",
      /** Superfície primária suave no modo escuro (ex.: ícones / chips). */
      muted: "#3A2229",
    },
    brandScheme: {
      100: "#F5DFE5",
      200: "#EBC0CC",
      300: "#D98A9E",
      400: "#D94A72",
      500: "#CF305D",
      600: "#B82A52",
      700: "#9E2448",
      800: "#7A1D38",
      900: "#501326",
    },
    brandTabs: {
      100: "#F5DFE5",
      200: "#CF305D",
      300: "#CF305D",
      400: "#CF305D",
      500: "#CF305D",
      600: "#B82A52",
      700: "#9E2448",
      800: "#7A1D38",
      900: "#501326",
    },
    secondaryGray: {
      100: "#E0E5F2",
      200: "#E1E9F8",
      300: "#F4F7FE",
      400: "#D0D5DD",
      500: "#667085",
      600: "#98A2B3",
      700: "#707EAE",
      800: "#707EAE",
      900: "#1B2559",
    },
    red: {
      100: "#FEE4E2",
      500: "#F53F3F",
      600: "#E02D2D",
    },
    blue: {
      50: "#EFF8FF",
      500: "#2E90FA",
    },
    orange: {
      100: "#FEF0C7",
      500: "#F79009",
    },
    green: {
      100: "#D1FADF",
      500: "#12B76A",
    },
    navy: {
      50: "#E8EBF2",
      100: "#C5CCD9",
      200: "#9FABC0",
      300: "#7A8AA6",
      400: "#55698D",
      500: "#3D4F73",
      600: "#2F3D5C",
      700: "#2A3548",
      800: "#1B2433",
      900: "#111822",
    },
    gray: {
      100: "#FAFCFE",
    },
  },
  styles: {
    global: (props: any) => ({
      body: {
        overflowX: "hidden",
        bg: mode("secondaryGray.300", "navy.900")(props),
        fontFamily: "DM Sans",
        letterSpacing: "-0.5px",
      },
      input: {
        color: "gray.700",
      },
      html: {
        fontFamily: "DM Sans",
      },
    }),
  },
};
